import strToColor from './strToColor.js'
import { SocketIoClient } from './SocketIo.js'

/** @typedef {import('yjs').Doc} YDoc */

class YProvider extends SocketIoClient {
  /** @type {YDoc} */
  yDoc
  /** @type {string} */
  roomName
  /** @type {boolean} */
  synced
  /** @type {import('y-protocols/awareness').Awareness} */
  awareness
  /** @type {import('socket.io-client').Socket|null} */
  yjsSocket

  /**
   * @param {string} roomName
   * @param {YDoc} doc
   */
  constructor (roomName, doc) {
    super()
    this.roomName = roomName
    this.yDoc = doc

    const awareness = new Y.awarenessProtocol.Awareness(doc)
    doc.awareness = this.awareness = awareness

    awareness.setLocalStateField('user', {
      name: window.CONFIG.user_name,
      firstname: window.CONFIG.user_firstname,
      lastname: window.CONFIG.user_lastname,
      email: window.CONFIG.email,
      color: strToColor(window.CONFIG.user_id)
    })

    const { socketIo } = this
    socketIo.socket.emitWithAck('join_yjs', roomName).then(response => {
      this.yjsSocket = socketIo.createSocket(response.namespace)
      this.initSyncListeners()
      this.initAwarenessListeners()

      // console.log(response, this.yjsSocket, this.yDoc)
    }, error => {
      console.error(this, error)
    })
  }

  initSyncListeners () {
    const { yjsSocket, yDoc } = this

    yDoc.on('update', (update, origin) => {
      if (origin === this) return
      yjsSocket.emit('sync-update', update)
    })

    yjsSocket.on('sync-step-1', (stateVector, syncStep2) => {
      syncStep2(Y.encodeStateAsUpdate(yDoc, new Uint8Array(stateVector)))
      this.synced = true
    })
    yjsSocket.on('sync-update', update => {
      Y.applyUpdate(yDoc, new Uint8Array(update), this)
    })

    yjsSocket.emit('sync-step-1', Y.encodeStateVector(yDoc), update => {
      Y.applyUpdate(yDoc, new Uint8Array(update), this)
    })
  }

  initAwarenessListeners () {
    const { yjsSocket, awareness } = this

    awareness.on('update', ({ added, updated, removed }) => {
      const changedClients = added.concat(updated, removed)
      const update = Y.awarenessProtocol.encodeAwarenessUpdate(awareness, changedClients)
      yjsSocket.emit('awareness-update', update)
    })

    yjsSocket.on('awareness-update', update => {
      Y.awarenessProtocol.applyAwarenessUpdate(awareness, new Uint8Array(update), this)
    })

    const update = Y.awarenessProtocol.encodeAwarenessUpdate(awareness, Array.from(awareness.getStates().keys()))
    yjsSocket.emit('awareness-update', update)
  }

  destroy () {
    this.yjsSocket?.disconnect()
    super.destroy()
  }
}

/**
 * @param {string} roomName
 */
export async function createYConnection (roomName) {
  const doc = new Y.Doc()
  doc.provider = new YProvider(roomName, doc)
  return doc
}
